import { apiThunk } from '../../Utils/apiThunk';
import type { AppDispatch } from '../../Store/types';
import type { paths } from '../../Types/api';
import type { VossFeatureFlag, VossFeatureFlagUpdate } from '../../Components/Voss/FeatureFlags/VossFeatureFlags.types';

type VossFeatureFlagList = paths['/api/vossfeatureflags']['get']['responses'][200]['content']['application/json'];

const LOADING_KEY = 'vossFeatureFlags';

// The name goes through encodeURIComponent exactly once; the thunks are called with preEncoded so apiFetch does not encodeURI it again.
export const vossFeatureFlagUrl = (name?: string) => `/api/vossfeatureflags${name === undefined ? '' : `/${encodeURIComponent(name)}`}`;

const vossFeatureFlagActions = {
    getAll: () => (dispatch: AppDispatch) => dispatch(apiThunk<VossFeatureFlagList>(vossFeatureFlagUrl(), { loadingKey: LOADING_KEY, preEncoded: true })),

    update: (name: string, update: VossFeatureFlagUpdate) => (dispatch: AppDispatch) =>
        dispatch(
            apiThunk<VossFeatureFlag>(vossFeatureFlagUrl(name), {
                loadingKey: LOADING_KEY,
                init: { method: 'PUT', body: JSON.stringify(update) },
                rethrow: true,
                preEncoded: true,
            })
        ),

    remove: (name: string) => (dispatch: AppDispatch) =>
        dispatch(apiThunk<null>(vossFeatureFlagUrl(name), { loadingKey: LOADING_KEY, init: { method: 'DELETE' }, rethrow: true, preEncoded: true })),
};

export default vossFeatureFlagActions;
